import { SolNavbar, SolNavbarItem } from '@sol/components';
import { AsmRouteId } from '@asm/components-core/models/asm-route-id';
import { SolIcon } from '@sol/icons';

export const navbarLicensing: SolNavbar = {
  menu: [
    SolNavbarItem.of(AsmRouteId.licensing_dashboard, {
      displayName: 'asm-route.licensing-dashboard',
      icon: SolIcon.asm_dashboard,
    }),
    SolNavbarItem.of(AsmRouteId.licensing_customers, {
      displayName: 'asm-route.licensing-customers',
      icon: SolIcon.users,
    }),
    SolNavbarItem.of('catalog', {
      displayName: 'asm-licensing.nav.catalog',
      icon: SolIcon.license,
      children: [
        SolNavbarItem.of(AsmRouteId.licensing_licenses, {
          displayName: 'asm-route.licensing-licenses',
          icon: SolIcon.license,
          showChildrenInNavbar: false,
          children: [
            SolNavbarItem.of(AsmRouteId.licensing_licenses_edit, {
              displayName: 'asm-route.licensing-licenses-edit',
              nameParams: ['name'],
            }),
          ],
        }),
        SolNavbarItem.of(AsmRouteId.licensing_actions, {
          displayName: 'asm-route.licensing-actions',
          icon: SolIcon.application,
        }),
        SolNavbarItem.of(AsmRouteId.licensing_units, {
          displayName: 'asm-route.licensing-units',
          icon: SolIcon.bookmark,
        }),
      ],
    }),
    SolNavbarItem.of('usage', {
      displayName: 'asm-licensing.nav.usage',
      icon: SolIcon.usage,
      children: [
        SolNavbarItem.of(AsmRouteId.licensing_metrics, {
          displayName: 'asm-route.licensing-metrics',
          icon: SolIcon.asm_dashboard,
        }),
        SolNavbarItem.of(AsmRouteId.licensing_events, {
          displayName: 'asm-route.licensing-events',
          icon: SolIcon.bookmark,
        }),
      ],
    }),
    SolNavbarItem.of(AsmRouteId.licensing_documentation, {
      displayName: 'asm-route.licensing-documentation',
      icon: SolIcon.bookmark,
    }),
  ],
  system: [],
  account: [
    SolNavbarItem.of(AsmRouteId.account_preferences, { displayName: 'asm-route.preferences', icon: SolIcon.settings }),
    SolNavbarItem.of(AsmRouteId.account_logout, { displayName: 'asm-route.logout' }),
  ],
};
